import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

/**
 * Styling for the meeting-note action-item editor: the list, each item's bordered row (text + a
 * grid of assignee / due-date controls), the remove affordance, and the "Add action item" link.
 * All tokens come from `THEME`.
 */
export const meetingActionItemsStyles = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	row: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.sm,
	},
	rowTop: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	rowBottom: {
		display: 'grid',
		gap: THEME.spacing.sm,
		gridTemplateColumns: '1fr 1fr',
		[THEME.queries.sm]: {
			gridTemplateColumns: '1fr',
		},
	},
	textInput: {
		flex: 1,
	},
	removeButton: {
		color: THEME.colors.text.light,
		flexShrink: 0,
		height: 'auto',
		padding: THEME.spacing.xs,
	},
	autocompleteControl: {
		width: '100%',
	},
	addButton: {
		alignSelf: 'flex-start',
		gap: THEME.spacing.xs,
		// Override the components-v2 Button's fixed height/padding so it reads as an inline link.
		height: 'auto',
		padding: 0,
	},
});
